import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-748ab79e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }

import { watch, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'X1Button',
  props: {
    labelProp: {
        type: String,
    }
},
  setup(__props) {

const props = __props



const label = ref(props.labelProp);

watch(() => props.labelProp, (newVal) => {
    if (newVal) {
        label.value = newVal;
    } else {
        label.value = '';
    }
});


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, _mergeProps(_ctx.$attrs, { class: "button-font" }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "buttonIcon"),
      _createElementVNode("span", _hoisted_1, _toDisplayString(label.value), 1),
      _renderSlot(_ctx.$slots, "buttonIconRight")
    ]),
    _: 3
  }, 16))
}
}

})